import store from 'store';
import { dependentsReset } from 'store/slices/dependents/dependents.middleware';

export function dependentsMiddleware(): any {
  return (next: any) => async (action: any) => {
    return dependentsReset(store)(next)(action);
  };
}
